import React from "react";
import { Link } from "react-router-dom";
export default function IndexTile(props) {
  return (
    <div className={props.className}>
      <Link to={props.link}>
        <div
          className={`card cursor-pointer card-custom card-stretch gutter-b bg-hover-light ${props.cardClass}`}
        >
          <div className="card-body">
            <span
              className={`svg-icon svg-icon-${props.iconColor} svg-icon-3x ml-n1`}
            >
              {props.icon}
            </span>
            <div className="text-inverse-white font-weight-bolder font-size-h5 mb-2 mt-5">
              {props.title}
            </div>
            <div className="font-weight-bold text-inverse-white font-size-sm">
              {props.description}
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
}
